module.exports = __webpack_public_path__ + "assets/img/service-b8febf55.png";